// src/pages/Home.jsx
import React, { useState, Suspense, lazy, useEffect } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
// import { useNavigate } from 'react-router-dom';
import Header from '../components/landing/Header';
import NavBar from '../components/NavBar';

// Optimized lazy loading with preloading hints
const ChatSection = lazy(() => import('../components/landing/ChatSection'), {
  // Add a small delay to prioritize critical content
  suspense: true
});

const HowItWorksSection = lazy(() => import('../components/landing/HowItWorksSection'), {
  suspense: true
});

const PricingSection = lazy(() => import('../components/landing/PricingSection'), {
  suspense: true
});

const DynamicGallery = lazy(() => import('../components/landing/DynamicGallery'), {
  suspense: true
});

const Feed = lazy(() => import('../components/landing/Feed'), {
  suspense: true
});

const Footer = lazy(() => import('../components/landing/Footer'), {
  suspense: true
});

// Optimized loading component with better UX
const SectionLoader = ({ height = "h-96", message = "Loading..." }) => (
  <div className={`${height} flex items-center justify-center bg-gray-900/50`}>
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-500 mb-4 mx-auto"></div>
      <p className="text-gray-400 text-sm">{message}</p>
    </div>
  </div>
);

function Home() {
  const { isSignedIn, isLoaded } = useAuth();
  const { user } = useUser();
  // const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('home');
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);

  // Handle user actions for NavBar
  const handleUserAction = (actionCallback) => {
    actionCallback();
  };

  // Optimize header visibility for better perceived performance
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsHeaderVisible(true);
    }, 100); // Small delay to prioritize critical content
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-black min-h-screen overflow-hidden flex flex-col">
      {/* Conditionally render NavBar only when authenticated */}
      {isLoaded && isSignedIn && user && (
        <NavBar 
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          handleUserAction={handleUserAction}
        />
      )}
      
      {/* Main content with conditional margin for NavBar */}
      <div className={`flex flex-col min-h-screen ${
        isLoaded && isSignedIn && user ? 'md:ml-20' : ''
      }`}>
        {/* Header loads immediately with optimized visibility */}
        {isHeaderVisible && <Header />}
        
        <main className="flex-1 pt-20">
          {/* ChatSection with optimized lazy loading */}
          {/* <Suspense fallback={<SectionLoader height="h-screen" message="Loading chat interface..." />}>
            <ChatSection />
          </Suspense> */}
          
          {/* DynamicGallery with optimized lazy loading */}
          {/* <Suspense fallback={<SectionLoader height="h-screen" message="Loading gallery..." />}>
            <DynamicGallery />
          </Suspense> */}

          {/* Feed Gallery with optimized lazy loading */}
          <Suspense fallback={<SectionLoader height="h-screen" message="Loading feed..." />}>
            <Feed />
          </Suspense>

          {/* HowItWorksSection with optimized lazy loading */}
          <Suspense fallback={<SectionLoader message="Loading features..." />}>
            <HowItWorksSection />
          </Suspense>

          {/* PricingSection with optimized lazy loading */}
          <Suspense fallback={<SectionLoader message="Loading pricing..." />}>
            <PricingSection />
          </Suspense>
          
        </main>
        
        {/* Footer with optimized lazy loading */}
        <Suspense fallback={<SectionLoader height="h-32" message="Loading footer..." />}>
          <Footer />
        </Suspense>
      </div>
    </div>
  );
}

export default Home;